export default __webpack_public_path__ + "static/media/paymentTutorial_pc_top_En.413d59a6.webp";